module.exports = __webpack_public_path__ + "img/mobileladdercontrol1.553299ba.png";